export const ou_valid_email_extensions = [
    'ou.edu',
    'ouhsc.edu',
    'oupm.org',
    'sooner.net',
    'alumni.ou.edu',
    'price.ou.edu',
    // Add more emails extensions here
];